import { ADDDRIVER } from '../Actions/types';

export const entryValue = (objName, value) => dispatch => {
    dispatch({
        type: ADDDRIVER,
        payload: value,
        objName: objName
    });
}